import { z } from "zod";

const companyListSchema = z.object({
  iCafeId: z.string(),
  pcCafeAccount: z.string(),
  companyName: z.string(),
});

export const identityCheckResponseSchema = z.object({
  phone: z.string(),
  loginName: z.string(),
  personName: z.string(),
  companyList: z.array(companyListSchema).optional(),
});

export type IdentityCheckResponseType = z.infer<typeof identityCheckResponseSchema>;
